<template>
    <div id="subscription-upgrade-existing-subscription-card">
        <b-card v-if="apparatusesToUpdate && apparatusesToUpdate.length && subscriptionProduct"
            class="paid-subs-info-card mb-0 sub-card mx-1" body-class="subs-info-card-body"
            data-test-hook="existing-subscription-modal-paid-card">
            <template #header>
                <div data-test-hook="subscription-upgrade-existing-subscription-card-header" class="plan-header">
                    {{ subscriptionProduct.name }}
                </div>
            </template>

            <div class="subscriptionCardText mt-3">
                <b-row>
                    <b-col>
                        <strong v-if="subscriptionProduct && subscriptionProduct.description"
                            data-test-hook="existing-subscription-modal-premium-monitoring-max-products-text">
                            {{ subscriptionProduct.description }}
                        </strong>
                    </b-col>
                </b-row>
                <b-row v-for="(apparatus, index) in apparatusesToUpdate" :key="index">
                    <ExpandableHsbSubscriptionFeaturesList v-if="apparatus.type === 0 || apparatus.apparatusType === 0"
                        :id="`${apparatus.apparatusId}-${'current'}`" :generator-name="apparatus.name"
                        :is-covered="true" />
                    <ExpandableTankSubscriptionFeaturesList
                        v-else-if="apparatus.type === 2 || apparatus.apparatusType === 2"
                        :id="`${apparatus.apparatusId}-${'current'}`" :tank-name="apparatus.name" :is-covered="true" />
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
import ExpandableHsbSubscriptionFeaturesList from './ExpandableHsbSubscriptionFeaturesList.vue'
import ExpandableTankSubscriptionFeaturesList from './ExpandableTankSubscriptionFeaturesList.vue'

export default {
    props: ['subscriptionProduct', 'apparatusesToUpdate'],

    components: {
        ExpandableHsbSubscriptionFeaturesList,
        ExpandableTankSubscriptionFeaturesList
    },
}
</script>
<style lang="scss">
#subscription-upgrade-existing-subscription-card {
    h1 {
        font-weight: normal;
        line-height: 1.15;
    }

    .plan-details-header {
        font-size: 1.125em;
        line-height: 1.25;
        font-weight: 500;
    }

    .plan-header {
        text-align: center;
        padding: 5px 0px;
        font-size: 1.45em;
        line-height: 1.35;
        font-weight: 500;
    }

    .card-header {
        align-items: stretch;
        padding: 0;
        border-bottom: 0;
        height: 40px;
    }

    .sub-radio-dot {
        font-size: 0.875rem !important;
    }

    .paid-subs-info-card-new {
        &.current {
            border: 2px solid var(--carbon-300) !important;

            .plan-header {
                background-color: var(--carbon-300);
            }
        }

        &.new {
            border: 2px solid var(--brand-400) !important;

            .plan-header {
                background-color: var(--brand-400) !important;
            }
        }
    }

    .paid-subs-info-card {
        border: 2px solid var(--carbon-300) !important;
        padding: 0;
        border-radius: 8px;

        .plan-header {
            background-color: var(--carbon-300);
        }
    }

    .feature-list {
        strong {
            font-size: 14px;
        }
    }

    .card-title {
        margin-bottom: 0;
    }

    .cost-label {
        color: var(--carbon-900);
        font-size: 30px;
        font-weight: bold;
        border-color: var(--brand-600);
        border-width: 2px;
        margin-bottom: 10px;
    }

    .cadence-text {
        font-size: 16px !important;
    }

    .subs-info-card-body {
        padding: 15px 30px !important;
    }

    .split-button-left-primary {
        position: relative;
        display: inline-block;
        padding: 10px 20px;
        border: 2px solid #1a5690;
        color: white;
        font-size: 16px;
        cursor: pointer;
        background: linear-gradient(to right, #1a5690 50%, #f9fafa 50%);
    }

    .split-button-right-primary {
        position: relative;
        display: inline-block;
        padding: 10px 20px;
        border: 2px solid #1a5690;
        color: white;
        font-size: 16px;
        cursor: pointer;
        background: linear-gradient(to right, #f9fafa 50%, #1a5690 50%);
    }
}
</style>
